export default __webpack_public_path__ + "static/media/manage_system.2944246d.svg";